import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {UiService} from "../../services/ui.service";
import {Melody} from "../../model/melody";
import {Artist} from "../../model/artist";
import {ContentService} from "../../services/content.service";
import {Tag} from "../../model/tag";
import {DeviceService} from "../../services/device.service";
import {ClassService} from "../../services/class.service";

@Component({
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.css']
})
export class HeaderMenuComponent implements OnInit, OnDestroy {
  headerOpened: boolean;
  showHits: boolean;
  searchText: string;

  tags: ReadonlyArray<Tag>;

  hitsMelodies: ReadonlyArray<Melody>;
  searchMelodiesResult: ReadonlyArray<Melody>;
  searchArtistsResult: ReadonlyArray<Artist>;
  searchMelodiesCount: number;
  searchArtistsCount: number;

  melodiesLoadInProgress: boolean;
  artistsLoadInProgress: boolean;

  melodiesPageSize: number;
  artistsPageSize: number;

  subscription: Subscription;
  melodiesLoadSubscription: Subscription;
  artistsLoadSubscription: Subscription;
  melodiesCountLoadSubscription: Subscription;
  artistsCountLoadSubscription: Subscription;

  constructor(private readonly uiService: UiService,
              private readonly contentService: ContentService,
              private readonly classService: ClassService,
              readonly deviceService: DeviceService) {
    this.headerOpened = false;
    this.showHits = false;
    this.searchText = '';

    this.hitsMelodies = [];
    this.searchMelodiesResult = [];
    this.searchArtistsResult = [];

    this.searchMelodiesCount = 0;
    this.searchArtistsCount = 0;

    this.melodiesLoadInProgress = false;
    this.artistsLoadInProgress = false;

    this.melodiesPageSize = deviceService.searchMelodiesSize;
    this.artistsPageSize = deviceService.searchArtistsSize;

    this.subscription = new Subscription();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.contentService.tagsList.subscribe(value => this.tags = value)
    );
    this.subscription.add(
      this.contentService.hitsMelodies.subscribe(value => this.hitsMelodies = value.slice(0, this.melodiesPageSize))
    );
    this.subscription.add(
      this.uiService.headerOpened.subscribe(value => this.headerOpened = value)
    );
    this.subscription.add(
      this.uiService.searchText.subscribe(value => this.search(value))
    );
  }

  search(text: string): void {
    this.searchText = text ? text.trim() : null;
    this.clearSearch();

    if (this.searchText && this.searchText.length >= 3) {
      this.showHits = false;

      this.loadMelodiesCount();
      this.loadArtistsCount();

      this.loadMelodies(this.melodiesPageSize);
      this.loadArtists(this.artistsPageSize);
    } else {
      this.showHits = true;
    }
  }

  clearSearch(): void {
    this.searchMelodiesResult = [];
    this.searchArtistsResult = [];

    if (this.melodiesCountLoadSubscription) {
      this.melodiesCountLoadSubscription.unsubscribe();
      this.melodiesCountLoadSubscription = null;
    }

    if (this.melodiesLoadSubscription) {
      this.melodiesLoadSubscription.unsubscribe();
      this.melodiesLoadSubscription = null;
    }

    if (this.artistsCountLoadSubscription) {
      this.artistsCountLoadSubscription.unsubscribe();
      this.artistsCountLoadSubscription = null;
    }

    if (this.artistsLoadSubscription) {
      this.artistsLoadSubscription.unsubscribe();
      this.artistsLoadSubscription = null;
    }

    this.melodiesLoadInProgress = false;
    this.artistsLoadInProgress = false;
  }

  searchAllMelodies(): void {
    this.loadMelodies(this.searchMelodiesCount);
  }

  loadMelodiesCount(): void {
    this.melodiesCountLoadSubscription = this.contentService.searchMelodiesCount(this.searchText)
      .subscribe(count => this.searchMelodiesCount = count);
  }

  loadMelodies(size: number): void {
    if (!this.melodiesLoadInProgress) {
      this.melodiesLoadInProgress = true;

      this.melodiesLoadSubscription = this.contentService.searchMelodies(this.searchText, 0, size)
        .subscribe((melodies) => {
          this.searchMelodiesResult = melodies;
          this.melodiesLoadInProgress = false;
          this.melodiesLoadSubscription = null;
        });
    }
  }

  searchAllArtists(): void {
    this.loadArtists(this.searchArtistsCount);
  }

  loadArtistsCount(): void {
    this.artistsCountLoadSubscription = this.contentService.searchArtistsCount(this.searchText)
      .subscribe(count => this.searchArtistsCount = count);
  }

  loadArtists(size: number): void {
    if (!this.artistsLoadInProgress) {
      this.artistsLoadInProgress = true;

      this.artistsLoadSubscription = this.contentService.searchArtists(this.searchText, 0, size)
        .subscribe((melodies) => {
          this.searchArtistsResult = melodies;
          this.artistsLoadInProgress = false;
          this.artistsLoadSubscription = null;
        });
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getIconClass(tag: Tag) {
    return this.classService.getIconClass(tag)
  }
}
